import * as React from "react";
import {cx}       from "emotion";
import "./vouchers-route.scss";

import {cs}              from "@Common/react/chain-services";
import {keyed}           from "@Common/react/keyed";
import {formatMoney}     from "@Common/ui-components/language/format-money";
import {parseDate}       from "@Common/utils/date-object";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";
import {isEmpty, values} from "@Common/utils/objects";

import {WalletLayout}     from "../common/wallet-layout";
import {isVoucherExpired} from "../../admin/accounting/admin-vouchers-route/details-modal/details-modal";

import {DetailsModal} from "./details-modal/details-modal";

export const AccountVouchersRoute = ({}) => cs(
    ["layout", ({}, next) => WalletLayout({activeTab: "vouchers", next})],
    ["detailsModal", (_, next) => DetailsModal({next})],
    ({detailsModal, layout: {vouchers}}) => (
        <div className="vouchers-route-52k">

            {!vouchers ? (
                <div className="no-data" xd-qa-type="label" xd-qa-name="Loading">
                    Loading...
                </div>
            ) : isEmpty(vouchers) ? (
                <div className="no-data" xd-qa-type="label" xd-qa-name="Empty">
                    No vouchers available
                </div>
            ) : (
                values(vouchers).map((voucher) => cs(
                    keyed(voucher.idPrimary),
                    () => (
                        <div className="card" xd-qa-type="card" xd-qa-name={voucher.name}>
                            <div className="line1">
                                <div className="left">

                                    <div className="label" xd-qa-type="label" xd-qa-name="Available in">
                                        Available in
                                    </div>
                                    <div className="title" title={`${voucher.name} Program`} xd-qa-type="text" xd-qa-name={voucher.name + " Program"}>
                                        {voucher.name} Program
                                    </div>

                                    <div className="actions">
                                        <a onClick={() => detailsModal.show(voucher)} xd-qa-type="link" xd-qa-name="Details">
                                            Details
                                        </a>
                                    </div>
                                </div>

                                <div className="right">

                                    <div className="line" xd-qa-type="text" xd-qa-name={voucher.total}>
                                        {formatMoney(voucher.total, {useFreeLabel: false})}
                                    </div>
                                    {(isVoucherExpired(voucher) || isVoucherExpiring(voucher)) && 
                                        <div className={cx("line badge", {"expired": isVoucherExpired(voucher), "warning": isVoucherExpiring(voucher)})}
                                            xd-qa-type="badge"
                                            xd-qa-name={daysUntilVoucherExpires(voucher)}
                                        >
                                            {daysUntilVoucherExpires(voucher)}
                                        </div>
                                    }
                                </div>

                                
                            </div>

                            <div className="details-train">
                                <div className="car">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Order Usage History">
                                        Order Usage History
                                    </div>
                                    <div className="value" xd-qa-type="text" xd-qa-name="Usage Amount">
                                        {voucher.usage?.length ?? 0} Times
                                    </div>
                                </div>
                                <div className="car">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Balance updated on">
                                        Balance Updated on
                                    </div>
                                    <div className="value" xd-qa-type="text" xd-qa-name="Balance Updated Date">
                                        {parseDateFormat("MMM dd, yyyy").formatDate(parseDate(voucher.dateModified))}
                                    </div>
                                </div>
                                {voucher.dateExpiration && parseDate(voucher.dateExpiration) && <div className="car">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Expiration Date">
                                        Expiration Date
                                    </div>
                                    <div className="value" xd-qa-type="text" xd-qa-name="Expiration Date">
                                        {parseDateFormat("MMM dd, yyyy").formatDate(parseDate(voucher.dateExpiration))}
                                    </div>
                                </div>}
                            </div>
                        </div>
                    )
                ))
            )}
        </div>
    ),
);

const isVoucherExpiring = (voucher)=> {
    const today = new Date();
    const expDate = voucher.dateExpiration !== null ? new Date(voucher.dateExpiration) : new Date(NaN)
    const timeDiff = expDate.getTime() - today.getTime();
    const daysDiff = timeDiff / (1000 * 60 * 60 * 24);
  
    return daysDiff >= 0 && daysDiff <= 14 && !isNaN(expDate.getTime());
};

export const daysUntilVoucherExpires = (voucher: { dateExpiration: string | null }) => {
    const today = new Date();
    const expDate = voucher.dateExpiration ? new Date(voucher.dateExpiration) : NaN;
  
    if (expDate instanceof Date) {
      const timeDiff = expDate.getTime() - today.getTime();
      const daysDiff = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
      return daysDiff <= 0 ? "Expired" : daysDiff == 1 ? daysDiff + " Day Left" : daysDiff + " Days Left";
    }
    return null; // or return any other value to indicate an invalid expiration date
};